import { uniqueId } from 'lodash';
import { API_ROOT_URL, GET_MEMBERS_API, GET_MEMBERS_API_V4 } from '../config/constant/apiConstant';
import api from '../helpers/axiosHelper';
import { objectToSearchParams } from '../helpers/jsHelper';
import { paginatedTeamActions } from '../redux/slicers/team/paginatedTeamSlicer';
import { searchMembersActions } from '../redux/slicers/searchMembersSlicer';
import { createGetListAction } from './apiGenerator';

export const getMembersApi = createGetListAction({
  //   endpoint: GET_MEMBERS_LIST_API,
  endpoint: GET_MEMBERS_API,
  actions: searchMembersActions,
  defaultSort: 'name',
});

export const getTeamMemberListApi =
  ({ page, perPage, sort, project_type, ...rest }) =>
  (dispatch) => {
    const searchParams = objectToSearchParams({ page, per_page: perPage, sort, ...rest });
    const API_URL = `${GET_MEMBERS_API}?${searchParams}`;
    const requestId = uniqueId();
    dispatch(paginatedTeamActions.fetchListStart({ requestId }));
    return api()
      .root(API_ROOT_URL)
      .get(API_URL)
      .success((data) => {
        dispatch(
          paginatedTeamActions.fetchListSuccess({
            page: page,
            data,
            requestId,
          })
        );
      })
      .error((error) => {
        // TODO: add logger
        console.error(error);
        dispatch(paginatedTeamActions.fetchListFailed({ error, requestId }));
      })
      .send();
  };

  export const getTeamMemberListApiV4 =
  ({ page, perPage, sort, project_type, ...rest }) =>
  (dispatch) => {
    const searchParams = objectToSearchParams({ page, per_page: perPage, sort, ...rest });
    const API_URL = `${GET_MEMBERS_API_V4}?${searchParams}`;
    const requestId = uniqueId();

    dispatch(paginatedTeamActions.fetchListStart({ requestId }));

    return api()
      .root(API_ROOT_URL)
      .get(API_URL)
      .success((data) => {
        dispatch(
          paginatedTeamActions.fetchListSuccess({
            page: page,
            data,
            requestId,
          })
        );
      })
      .error((error) => {
        // TODO: add logger
        console.error(error);
        dispatch(paginatedTeamActions.fetchListFailed({ error, requestId }));
      })
      .send();
  };
